import * as React from 'react';
import { NotFound } from '../DocParts/NotFound';
import { withTranslation } from '@wix/fe-essentials/i18n';
const InvoiceNotFound = ({ businessEmail, t }) => (React.createElement(NotFound, { messageText: t('invoice-view:invoice.not-found.message', { businessEmail }), headerText: t('invoice-view:invoice.not-found.header') }));
export default withTranslation(['invoice-view', 'locale-data'])(InvoiceNotFound);
//# sourceMappingURL=InvoiceNotFound.js.map